import { createDecorator } from '../definition/decorator';

export const lifecycleRules = createDecorator(
  'lifecycleRules',
  (attach) => (baseParams, runtime) => {
    let detached = false;

    const lifecycle = attach(baseParams, {
      ...runtime,
      next: (state) => {
        if (!detached) {
          runtime.next(state);
        } else {
          runtime.env.logger?.debug('no-opping state change after detach');
        }
      },
    });

    return {
      ...lifecycle,
      detach: () => {
        lifecycle.detach();
        detached = true;
      },
    };
  }
);
